import { decorate, observable } from 'mobx';
import ListData from '../toolkit/mobx-connectors/observables/list-data';

class ImportadoresStore {
  list = new ListData();
}

decorate(ImportadoresStore, {
  list: observable
});

const importadoresStore = new ImportadoresStore();
const importadoresFormStore = new ImportadoresStore();

export { importadoresFormStore };
export default importadoresStore;
